import axios from 'axios';

const DEFAULT_DOMAIN = '';
const API_PREFIX = '/marketplace';

export function getLoggedInUserInfo(options = {}) {
  const headers = {};
  const { cookie, domain = DEFAULT_DOMAIN } = options;
  const path = `${API_PREFIX}/me`;

  if (cookie) {
    headers.cookie = cookie;
  }

  return axios.get(path, { headers });
}

export default {
  getLoggedInUserInfo
};
